module.exports = __webpack_public_path__ + "img/selected7-min.fa7db001.png";